import { Component } from 'react';

import 'iframe-resizer/js/iframeResizer.contentWindow.min';
// Components
import ShingleColorDetail from './ShingleColorDetail';

export default class Page extends Component {
  state = {
    loading: true,
    shingleColors: null,
  };

  componentDidMount() {
    fetch(`${MDMS_URL}/api/v2/product/shingles/${this.props.shingle.uid}`)
      .then(response => response.json())
      .then(responseJSON => {
        const filteredShingleColors = responseJSON.shingle_colors;
        if (filteredShingleColors instanceof Array) {
          const filteredColorData = filteredShingleColors.map(color => {
            const {
              house_1229x768_url2,
              name,
              description,
              ranch_house_image_url,
              swatch_160x160_url,
              swatch_768x485_url,
              swatch_768x768_url,
              two_story_house_v1_image_url,
              two_story_house_v2_image_url,
              uid,
            } = color;
            return {
              house_1229x768_url2,
              name,
              description,
              ranch_house_image_url,
              swatch_160x160_url,
              swatch_768x485_url,
              swatch_768x768_url,
              two_story_house_v1_image_url,
              two_story_house_v2_image_url,
              uid,
            };
          });
          this.setState(state => ({ ...state, shingleColors: filteredColorData }));
        }
        this.setState(state => ({ ...state, loading: false }));
      })
      .catch(() => {
        this.setState(state => ({ ...state, loading: false }));
      });
  }

  shingleColors = () => this.state.shingleColors || this.props.shingle_colors;

  render() {
    return (
      <main>
        <ShingleColorDetail
          layout={this.props.layout}
          loading={this.state.loading}
          shingleColors={this.shingleColors()}
          allowedColors={this.props.allowed_colors}
          shingleLine={this.props.shingle.uid}
          shingleName={this.props.shingle.name}
          style={this.props.style}
          view={this.props.view}
          trudefinition={this.props.shingle.trudefinition}
          shingle={this.props.shingle}
        />
      </main>
    );
  }
}
